import $ from 'jquery';
import './common/select-option-plugin';
import 'html5-history-api';
import utils from '@bigcommerce/stencil-utils';
import PageManager from './page-manager';
import quickSearch from './global/quick-search';
import currencySelector from './global/currency-selector';
import mobileMenuToggle from './global/mobile-menu-toggle';
import menu from './global/menu';
import foundation from './global/foundation';
import byo from './global/byo';
import quickView from './global/quick-view';
import cartPreview from './global/cart-preview';
import compareProducts from './global/compare-products';
import privacyCookieNotification from './global/cookieNotification';
import maintenanceMode from './global/maintenanceMode';
import carousel from './common/carousel';
import 'lazysizes';
import loadingProgressBar from './global/loading-progress-bar';
import FastClick from 'fastclick';
import sweetAlert from './global/sweet-alert';
import Featherlight from './global/featherlight.min';
import FeatherlightGallery from './global/featherlight.gallery.min';

function fastClick(element) {
    return new FastClick(element);
}

export default class Global extends PageManager {
    /**
     * You can wrap the execution in this method with an asynchronous function map using the async library
     * if your global modules need async callback handling.
     * @param next
     */
    loaded(next) {
        fastClick(document.body);
        quickSearch();
        currencySelector();
        foundation($(document));
        byo(this.context);
        quickView(this.context);
        cartPreview();
        compareProducts(this.context.urls);
        carousel();
        menu();
        mobileMenuToggle();
        privacyCookieNotification();
        maintenanceMode(this.context.maintenanceMode);
        loadingProgressBar();
        sweetAlert();
        next();
    }
}

$(document).ready(function() {
	
    if (jQuery(document).scrollTop() > jQuery(".header").outerHeight() + jQuery(".hello-bar").outerHeight() - jQuery(".navPages-container").outerHeight()) {
        jQuery(".navPages-container").addClass("sticky-header");
        jQuery(".header").css("padding-bottom", jQuery(".navPages-container").outerHeight() + "px");
    }
    else {
        jQuery(".navPages-container").removeClass("sticky-header");
        jQuery(".header").css("padding-bottom", "0px");
    }
    
    // Mobile
    if (window.matchMedia('(max-width: 800px)').matches) {
        
        if (jQuery(document).scrollTop() > jQuery(".hello-bar").outerHeight()) {
            jQuery(".header-center").addClass("sticky-header");
            jQuery(".header").css("padding-bottom", jQuery(".header-center").outerHeight() + "px");
        }
        else {
            jQuery(".header-center").removeClass("sticky-header");
            jQuery(".header").css("padding-bottom", "0px");
        }
        
    }
    
});

jQuery(document).scroll(function(){

    if (jQuery(document).scrollTop() > jQuery(".header").outerHeight() + jQuery(".hello-bar").outerHeight() - jQuery(".navPages-container").outerHeight()) {
        jQuery(".navPages-container").addClass("sticky-header");
        jQuery(".header").css("padding-bottom", jQuery(".navPages-container").outerHeight() + "px");
    }
    else {
        jQuery(".navPages-container").removeClass("sticky-header");
        jQuery(".header").css("padding-bottom", "0px");
    }
    
    // Mobile
    if (window.matchMedia('(max-width: 800px)').matches) {
        
        if (jQuery(document).scrollTop() > jQuery(".hello-bar").outerHeight()) {
            jQuery(".header-center").addClass("sticky-header");
            jQuery(".header").css("padding-bottom", jQuery(".header-center").outerHeight() + "px");
        }
        else {
            jQuery(".header-center").removeClass("sticky-header");
            jQuery(".header").css("padding-bottom", "0px");
        }
        
    }

});

jQuery(".open-menu").click(function(){
    jQuery("#menu").addClass("is-open");
});

jQuery(".close-menu").click(function(){
    jQuery("#menu").removeClass("is-open");
});

jQuery(document).ready(function() {

    jQuery(".lightbox-image").css("height", jQuery(".lightbox-image").width() + "px");

    jQuery('.lightbox').featherlightGallery({
        previousIcon: '&#8249;',
        nextIcon: '&#8250;',
        galleryFadeIn: 100,
        galleryFadeOut: 300
    });
    
});

jQuery(window).resize(function() {
	
    jQuery(".lightbox-image").css("height", jQuery(".lightbox-image").width() + "px");

});

jQuery("body").on("click", ".byo-dropdown-header", function() {
    if(jQuery(this).parent().find(".byo-dropdown-content").height() > 0){
        jQuery(this).parent().removeClass("byo-dropdown-open");
        jQuery(this).parent().addClass("byo-dropdown-close");
    }
    else {
        jQuery(this).parent().removeClass("byo-dropdown-close");
        jQuery(this).parent().addClass("byo-dropdown-open");
        
        jQuery(this).parent().find(".byo-price").each(function(){
                    
            var byo_product = $(this).attr("byo-product");
            
            utils.api.product.getById(byo_product, { template: 'products/byo-price' }, (err, response) => {
                $(this).html(response);
            });
            
        });
        
    }
});

jQuery(".byo-brand").click(function(){
    jQuery(this).parent().parent().parent().find(".byo-brand").removeClass("active-selection");
    jQuery(this).addClass("active-selection");
});

jQuery("body").on("click", ".byo-dropdown-content .productOptions-list-item-image", function() {
    jQuery(this).parent().parent().parent().parent().find(".productOptions-list-item-image").removeClass("active-selection");
    jQuery(this).addClass("active-selection");
    var next_dropdown = jQuery(this).closest(".byo-dropdown-id").attr("next-dropdown");
    next_dropdown++;
    jQuery("#byo-dropdown-" + next_dropdown + " .byo-dropdown").removeClass("byo-dropdown-close");     
    jQuery("#byo-dropdown-" + next_dropdown + " .byo-dropdown").addClass("byo-dropdown-open");
    
    jQuery("#byo-dropdown-" + next_dropdown + " .byo-price").each(function(){
                    
        var byo_product = $(this).attr("byo-product");
        
        utils.api.product.getById(byo_product, { template: 'products/byo-price' }, (err, response) => {
            $(this).html(response);
        });
        
    });
    
});

jQuery("body").on("click", ".byo-dropdown-content .productOptions-list-item-figure", function() {
    jQuery(this).parent().parent().parent().find(".productOptions-list-item-image").removeClass("active-selection");
    jQuery(this).find(".productOptions-list-item-image").addClass("active-selection");
});

jQuery(".button-byo").click(function(){
    jQuery(".product-byo-section").css("display","block");
});

jQuery(".scroll-byo").click(function(){
    $('html, body').animate({
        scrollTop: ($('.product-byo-section').offset().top - 70)
    },500);
});

$('html, body').animate({
    scrollTop: ($('html').offset().top)
},500);

if (window.location.href.indexOf("?id") > -1) {
    jQuery(".option-id").css("display","block");
}

jQuery(document).ready(function() {

    if(jQuery(".section-3 .productCarousel-slide").length < 1){
        jQuery(".section-3").css("display","none");
    }
    
    if(jQuery(".section-0 .productCarousel-slide").length < 1){
        jQuery(".section-0").css("display","none");
    }
    
});

jQuery(".scroll-byo").click(function(){
    $('html, body').animate({
        scrollTop: ($('.product-byo-section').offset().top - 70)
    },500);
});

if (document.cookie.indexOf("agegate") < 0){
    jQuery('.age-gate').css("display","table"); 
}

jQuery("#age-gate-enter").click(function(){
    var hide_date = new Date();
    hide_date.setTime(hide_date.getTime() + (1*24*60*60*1000)); // 1 day
    var agegate_expires = "expires="+ hide_date.toUTCString();
    document.cookie = "agegate=1;" + agegate_expires + ";path=/";
  	jQuery('.age-gate').css("display","none"); 
});

jQuery("#age-gate-exit").click(function(){
    window.history.back();
});

jQuery("#age-gate-exit").click(function(){
    window.history.back();
});

jQuery('body').on('contextmenu', 'img', function(e){
    return false; 
});


jQuery(document).ready(function() {

    setTimeout(function(){ 
    
        var compare_number_1 = jQuery(".navUser-item--compare span").html();
        
        if(compare_number_1 == "4"){
            jQuery(".body").addClass("compare-disabled");
        }
        else {
            jQuery(".body").removeClass("compare-disabled");
        }
        
    }, 500);
    
});


var v = 1;

jQuery("body").on("click", "label.compare-button", function() {

    v++;
    
    if(v % 2 == 0) {

        if(jQuery(this).hasClass("compare-active")){
            jQuery(this).removeClass("compare-active");
        }
        else {
            jQuery(this).addClass("compare-active");
        }

        setTimeout(function(){ 
            
            var compare_number = jQuery(".navUser-item--compare span").html();
            
            if(compare_number == "4"){
                jQuery(".body").addClass("compare-disabled");
            }
            else {
                jQuery(".body").removeClass("compare-disabled");
            }
            
        }, 500);
        
    }

});


// WEBPACK FOOTER //
// ./assets/js/theme/global.js